import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'Teranet-PasswordExpireDialog',
  templateUrl: './password-expire-dialog.html'
})

export class PasswordExpireDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public days: number) { }
}
